'use client';
import { createContext, useContext, useState, ReactNode } from 'react';

// 存所有页面的 tab 键值对
type TabStore = Record<string, string>;

interface PageTabContextType {
    // 获取当前页面tab
    getTab: (pageKey: string) => string;
    // 设置当前页面tab
    setTab: (pageKey: string, tabKey: string) => void;
}

const PageTabContext = createContext<PageTabContextType | undefined>(undefined);

export function PageTabProvider({ children }: { children: ReactNode }) {
    // 全局存放所有页面的 tab 状态
    const [tabMap, setTabMap] = useState<TabStore>({});

    const getTab = (pageKey: string) => {
        return tabMap[pageKey] || '0';
    };

    const setTab = (pageKey: string, tabKey: string) => {
        setTabMap(prev => ({
            ...prev,
            [pageKey]: tabKey,
        }));
    };

    return (
        <PageTabContext.Provider value={{ getTab, setTab }}>
            {children}
        </PageTabContext.Provider>
    );
}

// 统一封装hook
export const usePageTab = () => {
    const ctx = useContext(PageTabContext);
    if (!ctx) throw new Error('请在 RootLayout 包裹 PageTabProvider');
    return ctx;
};
